document.querySelectorAll('[data-collection-sort]').forEach(form=>{
  form.querySelector('select')?.addEventListener('change',()=>form.requestSubmit());
});

const collectionSeoMedia = window.matchMedia('(max-width: 749px)');

document.querySelectorAll('[data-collection-section]').forEach((section) => {
  const content = section.querySelector('[data-collection-seo-content]');
  const toggle = section.querySelector('[data-collection-seo-toggle]');
  const label = toggle?.querySelector('[data-collection-seo-label]');
  if (!content || !toggle || !label) return;

  const update = () => {
    content.classList.remove('is-collapsed');
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'true');
    label.textContent = 'Show less';

    if (!collectionSeoMedia.matches || content.scrollHeight <= 190) return;

    content.classList.add('is-collapsed');
    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');
    label.textContent = 'Read more';
  };

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    content.classList.toggle('is-collapsed', expanded);
    toggle.setAttribute('aria-expanded', String(!expanded));
    label.textContent = expanded ? 'Read more' : 'Show less';
  });

  collectionSeoMedia.addEventListener('change', update);
  update();
});
